<template>

        <div class="widget has-shadow">

            <div class="widget-header bordered  d-flex align-items-center">
                <h2>نمودار میزان فروش این ماه فروشگاه</h2>
                <div class="widget-options">
                    <button type="button" class="btn btn-shadow">مشاهده همه</button>
                </div>
            </div>

            <div class="widget-body">
                <highcharts :options="chartOptions"></highcharts>
            </div>
        </div>


</template>

<script>
import myMinix from '../myMixin';
import {Chart} from 'highcharts-vue'

export default {
    mixins:[myMinix],
    data(){
        const app=this;
        return {
            chartOptions:{
                chart:{
                    type:'line',
                    style:{
                       fontFamily:'IRANSansWeb'
                    }
                },
                title: {
                    text: ''
                },    
                subtitle: {
                    text: ''
                },
                yAxis: {
                   title: {
                      text: ''
                   },
                   labels:{
                      useHTML:true,
                      formatter:function()
                      {
                          let value=this.value;
                          if(value>1000){
                             value=app.number_format(value);
                          }
                         value=app.replaceNumber(value);
                         return '<div style="direction:ltr">'
                         +'<span>'+value+'</span>'
                         +'</div>';
                      },
                    },
                    style:{
                        fontSize:'15px'
                     } 
                },
                legend: {
                    verticalAlign: 'top',
                    y:0
                },
                xAxis: {
                    categories:[]
                },
                series: [{
                     name: 'میزان فروش',
                     data: [],
                     color:'red'
                },{
                    name: 'تعداد تراکنش',
                    data: [],
                    marker:{
                       symbol:'circle'
                    }
               }],
               tooltip:{
                    useHTML:true,
                    formatter:function()
                    {
                       if(this.series.name=='میزان فروش'){
                          return this.x+'<br>'+'<div style="padding:5px">'+this.series.name+' : '+app.replaceNumber(app.number_format(this.y))+' تومان'+'</div>';
                       }
                       else{
                        return this.x+'<br>'+'<div style="padding:5px">'+this.series.name+' : '+app.replaceNumber(app.number_format(this.y))+' بار'+'</div>';
                      } 
                    },
                    style:{
                       fontSize:'15px'
                   }  
                },
               responsive: {
                   rules: [{
                      condition: {
                      maxWidth: 500
                   },
                  chartOptions: {
                      legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                  }
                }]
              }
            },
            account_status:'active',
            showLoading:false
        }
    },
    mounted(){
        this.getData();
    },
    components: {
       highcharts: Chart
    },
    methods:{
        getData()
        {
            const app=this;
            const url=this.$siteUrl+'/api/orders/get_month_sales_statistics';
            this.axios.get(url,this.setHeader()).then(response=>{
                const result=this.setAccountStatus(response.data);
                if(result)
                {
                   this.chartOptions['series'][0]['data']=[];
                   this.chartOptions['series'][1]['data']=[];
                   let price=response.data.price_array;
                   let count=response.data.count_array;
                   this.chartOptions['xAxis']['categories']=response.data.date_list;
                   price.forEach(function(row){
                       app.chartOptions['series'][0]['data'].push(row);
                   });
                   count.forEach(function(row){
                       app.chartOptions['series'][1]['data'].push(row);
                   })
                }
                this.$emit('show_account_status');
            }).catch((error)=>{
                this.setCatch(error);
            });
        }
    }
}
</script>

<style>

</style>